import { t } from 'i18next';
import { useGethowtobuy, useGetProfile } from '../Myprofile/api';
import Loader from '../../Loader/buttonLoad';

const HowToBuy = (props) => {
    const { data: getProfile } = useGetProfile()
    const {isLoading,data } = useGethowtobuy()
    console.log("🦁 ~ HowToBuy ~ data:", data)

    return (
        <div className='TrnsctnPg'>
            <div className='row'>
                <div className='col-lg-8'>
                    <div className="TrnsctnDts">
                        <div className="TrnsctnDtsTp">
                            <h4>{t('How to Buy')}</h4>
                        </div>
                        <div className='HwTByPg'>
                            <p>{t('Cryptocurrency Usage guide & Purchase Instruction for KKOG Coin')} </p>
                            <p>{t('To facilitate your understanding and utilization of various cryptocurrency apps, we have compiled a comprehensive list along with corresponding instruction videos for your convenience. Please refer to the following resources:')} </p>
                            <div className='HwTByDV'>
                              {isLoading ? <Loader/> : 

data?.data?.map((buylist) => (
                                <div className='HwTByDvDts' key={buylist.Howtobuytitle}>
                                    <label htmlFor="Coinbase">{buylist.Howtobuytitle}</label>
                                    <a target='blank' href={buylist?.buyurl}>{buylist?.buyurl}</a>
                                </div>
))
}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 CustPad">
                    <div className='DshbrdPrfl'>
                        <div className='DshbrdPrflTp'>
                            <h4>{t('Welcome')} <span>{getProfile?.data?.userName}</span></h4>
                        </div>
                        <div className='DshbrdPrflVrfy'>
                            <label>{t('Your Account Status')}</label>
                            <h5>{t('Email Verified')}<img src={require('../../assets/images/tick-circle.svg').default} alt='' /></h5>
                            <div className='mt-2'>
                                <label>{t('Receiving Wallet')}</label>
                                <p>{getProfile?.data?.walletAddress}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HowToBuy;